// Triggers a browser download from an in-memory Blob. Builds a transient
// `<a download>` link, clicks it, and revokes the object URL so we don't
// leak — after a delay, since a large Blob (shared files can be hundreds of
// MB) is still being read when `click()` returns. Pattern is the same as the
// whiteboard's local helper at
// `shared/components/ng-whiteboard/lib/ng-whiteboard.utils.ts:30` — lifted
// here so consumers outside the whiteboard package don't have to reach
// into it.
export function downloadFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
